export interface SessionSummaryApiResource {
  id: string;
  session_note_id: string;
  plain_language_text: string | null;
  medical_language_text: string | null;
  status: string;
  approved_at: string | null;
  approved_by_user_id: string | null;
  shared_with_client_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface SessionSummary {
  id: string;
  sessionNoteId: string;
  plainLanguageText: string | null;
  medicalLanguageText: string | null;
  status: string;
  approvedAt: string | null;
  approvedByUserId: string | null;
  sharedWithClientAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SessionSummaryWritePayload {
  plainLanguageText: string | null;
  medicalLanguageText: string | null;
}

export function mapApiResourceToSessionSummary(resource: SessionSummaryApiResource): SessionSummary {
  return {
    id: resource.id,
    sessionNoteId: resource.session_note_id,
    plainLanguageText: resource.plain_language_text,
    medicalLanguageText: resource.medical_language_text,
    status: resource.status,
    approvedAt: resource.approved_at,
    approvedByUserId: resource.approved_by_user_id,
    sharedWithClientAt: resource.shared_with_client_at,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}

export function mapSessionSummaryWritePayload(
  payload: SessionSummaryWritePayload
): Record<string, unknown> {
  return {
    plain_language_text: payload.plainLanguageText,
    medical_language_text: payload.medicalLanguageText,
  };
}
